/* ============================================================
   ONE WISH WILLOW — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── FAQ Accordion ─────────────────────────────────────── */
  document.querySelectorAll('.faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.faq__item');
      var answer = item.querySelector('.faq__answer');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = '0';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Cart Toast ─────────────────────────────────────────── */
  function showCartToast(msg) {
    var existing = document.getElementById('cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'cart-toast';
    toast.textContent = msg;
    Object.assign(toast.style, {
      position:     'fixed',
      bottom:       '24px',
      left:         '50%',
      transform:    'translateX(-50%)',
      background:   '#1e1e1e',
      color:        '#fff',
      padding:      '12px 24px',
      borderRadius: '8px',
      fontSize:     '0.9rem',
      zIndex:       '9999',
      whiteSpace:   'nowrap',
      pointerEvents:'none'
    });
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 4000);
  }

  function cartChange(line, newQty, item) {
    item.classList.add('is-updating');

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (res) {
        console.log('[cart] status:', res.status, res.ok);
        if (!res.ok) {
          item.classList.remove('is-updating');
          showCartToast('Sorry, no more stock available for this item.');
          return null;
        }
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;
        console.log('[cart] response:', cart);
        var updatedLine = cart.items && cart.items[line - 1];
        console.log('[cart] updatedLine qty:', updatedLine && updatedLine.quantity, 'requested:', newQty);
        if (newQty > 0 && updatedLine && updatedLine.quantity < newQty) {
          item.classList.remove('is-updating');
          showCartToast('Sorry, only ' + updatedLine.quantity + ' left in stock.');
          return;
        }
        location.reload();
      })
      .catch(function (err) {
        console.log('[cart] error:', err);
        item.classList.remove('is-updating');
        showCartToast('Something went wrong. Please try again.');
      });
  }

  /* ── Cart Quantity Stepper + Remove (delegated) ─────────── */
  document.addEventListener('click', function (e) {
    var target = e.target;

    if (target.closest('[data-qty-up]')) {
      var wrap   = target.closest('.cart-item__qty');
      var val    = wrap.querySelector('.cart-item__qty-val');
      var item   = target.closest('.cart-item');
      var line   = parseInt(item.dataset.line, 10);
      var newQty = parseInt(val.textContent.trim(), 10) + 1;
      cartChange(line, newQty, item);
    }

    if (target.closest('[data-qty-down]')) {
      var wrap   = target.closest('.cart-item__qty');
      var val    = wrap.querySelector('.cart-item__qty-val');
      var item   = target.closest('.cart-item');
      var line   = parseInt(item.dataset.line, 10);
      var newQty = parseInt(val.textContent.trim(), 10) - 1;
      if (newQty < 1) return;
      cartChange(line, newQty, item);
    }

    if (target.closest('[data-remove-item]')) {
      var item = target.closest('.cart-item');
      if (!item) return;
      var line = parseInt(item.dataset.line, 10);
      item.style.transition = 'opacity 0.3s';
      item.style.opacity    = '0';
      cartChange(line, 0, item);
    }
  });


  /* ── Card Type Selection ────────────────────────────────── */
  document.querySelectorAll('.card-type').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.card-type').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Play Button (video launch hook) ────────────────────── */
  document.querySelectorAll('[data-video-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = this.dataset.videoId;
      if (!id) return;
      // Replace with actual video modal / YouTube embed logic
      console.log('Open video:', id);
    });
  });

  /* ── Smooth scroll for anchor links ─────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
